"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var day_1 = require("./day");
var week_number_1 = require("./week_number");
var getStartOfWeek = require("date-fns/start_of_week");
var getISOWeek = require("date-fns/get_iso_week");
var addDays = require("date-fns/add_days");
var Week = /** @class */ (function (_super) {
    __extends(Week, _super);
    function Week() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleDayClick = function (day, event) {
            if (_this.props.onDayClick) {
                _this.props.onDayClick(day, event);
            }
        };
        _this.handleDayMouseEnter = function (day) {
            if (_this.props.onDayMouseEnter) {
                _this.props.onDayMouseEnter(day);
            }
        };
        _this.renderDays = function () {
            var startOfWeek = getStartOfWeek(_this.props.day, { weekStartsOn: 1 });
            var days = [];
            if (_this.props.showWeekNumber) {
                days.push(React.createElement(week_number_1.default, { key: "W", weekNumber: getISOWeek(startOfWeek) }));
            }
            return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
                var day = addDays(startOfWeek, offset);
                return (React.createElement(day_1.default, { key: offset, day: day, month: _this.props.month, onClick: _this.handleDayClick.bind(_this, day), onMouseEnter: _this.handleDayMouseEnter.bind(_this, day), minDate: _this.props.minDate, maxDate: _this.props.maxDate, inline: _this.props.inline, highlightDates: _this.props.highlightDates, includeDates: _this.props.includeDates, excludeDates: _this.props.excludeDates, filterDate: _this.props.filterDate, selectingDate: _this.props.selectingDate, preSelection: _this.props.preSelection, selected: _this.props.selected, selectsStart: _this.props.selectsStart, selectsEnd: _this.props.selectsEnd, startDate: _this.props.startDate, endDate: _this.props.endDate }));
            }));
        };
        return _this;
    }
    Week.prototype.render = function () {
        return React.createElement("div", { className: "ee_react-datepicker__week" }, this.renderDays());
    };
    Week.displayName = 'Week';
    Week.propTypes = {
        day: PropTypes.object.isRequired,
        endDate: PropTypes.object,
        minDate: PropTypes.object,
        maxDate: PropTypes.object,
        highlightDates: PropTypes.array,
        filterDate: PropTypes.func,
        excludeDates: PropTypes.array,
        includeDates: PropTypes.array,
        inline: PropTypes.bool,
        month: PropTypes.number,
        onDayClick: PropTypes.func,
        onDayMouseEnter: PropTypes.func,
        preSelection: PropTypes.object,
        selected: PropTypes.object,
        selectingDate: PropTypes.object,
        selectsEnd: PropTypes.bool,
        selectsStart: PropTypes.bool,
        showWeekNumber: PropTypes.bool,
        startDate: PropTypes.object
    };
    return Week;
}(React.Component));
exports.Week = Week;
exports.default = Week;
//# sourceMappingURL=week.js.map
